import { render, staticRenderFns } from "./SCShiftFilters.vue?vue&type=template&id=31ca5df3"
import script from "./SCShiftFilters.vue?vue&type=script&lang=js"
export * from "./SCShiftFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports